import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FlexContainer from '@components/FlexContainer/FlexContainer';

import ContactAddress from './components/ContactAddress/ContactAddress';
import ContactForm from './forms/ContactForm/ContactForm';
import ContactInfo from './components/ContactInfo/ContactInfo';

import {
  getContactDetails,
  sendContactFormData,
} from '@actions/contact';

import { contactDetails } from '@selectors/contact';

import './Contact.scss';

class Contact extends React.Component {
  componentDidMount() {
    this.props.fetchContactDetais();
  }

  render() {
    const {
      contactDetails,
      sendContactFormData,
    } = this.props;

    return (
      <FlexContainer>
        <div className="contact">
          <div className="contact__column">
            <div className="contact__info">
              <ContactInfo />
            </div>
            <div className="contact__form">
              <ContactForm onSubmit={data => sendContactFormData(data)} />
            </div>
          </div>
          <div className="contact__column">
            <ContactAddress contactDetails={contactDetails} />
          </div>
        </div>
      </FlexContainer>
    );
  }
}

Contact.propTypes = {
  contactDetails: PropTypes.object.isRequired,
  fetchContactDetais: PropTypes.func.isRequired,
  sendContactFormData: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  contactDetails: contactDetails(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchContactDetais: getContactDetails,
  sendContactFormData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Contact);



// WEBPACK FOOTER //
// ./src/routes/Contact/Contact.js